import React, { useEffect, useState } from 'react'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CLoadingButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CMultiSelect,
  CRow,
  CTooltip,
} from '@coreui/react-pro'
import Bootbox from 'bootbox-react'
import moment from 'moment'
import { cilArrowLeft, cilInfo, cilLink, cilList, cilReload, cilStar } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'
import CompleteMarkModal from './CompleteMarkModal'
import { Link, useParams, useNavigate } from 'react-router-dom'
import Loader from 'src/components/Loader'
import MarkAsCompleteModal from './MarkAsCompleteModal'
import { useFormik } from 'formik'
import ScorecardGrid from './ScorecardGrid'
import { hasScores } from './scorecardConfig'
import './ScoreCard.css'

// The borderless-alert InfoBox the import wizards use, copied rather than shared -
// same house convention as MiniStepper/StatTile.
const InfoBox = ({ children, color = 'info' }) => (
  <CAlert color={color} className="d-flex align-items-start gap-2 border-0 mb-3">
    <CIcon icon={cilInfo} className="flex-shrink-0 mt-1" />
    <div>{children}</div>
  </CAlert>
)

const CommonScorecard = (props) => {
  const navigate = useNavigate()
  const [commonScorecardLoading, setCommonScorecardLoading] = useState(false)
  const [finalScorecardModalVisible, setFinalScorecardModalVisible] = useState(false)
  const [statusValue, setStatusValue] = useState(props?.statusValue ?? 0)
  const [defaultInning, setDefaultInning] = useState(1)
  const [completMarkModalVisible, setCompletMarkModalVisible] = useState(false)
  const [visible, setVisible] = useState(false)
  const [detailsModalVisible, setDetailsModalVisible] = useState(false)
  const [bonusModalVisible, setBonusModalVisible] = useState(false)
  const formikRef = React.useRef()
  const formik = useFormik({
    initialValues: {
      data: props.scorecardDetails,
      scorcard_link_name: props.fixtureDetails?.scorcard_link_name,
      scorcard_link_url: props.fixtureDetails?.scorcard_link_url,
      fall_of_wickets: props.fixtureDetails?.fall_of_wickets,
      match_report: props.fixtureDetails?.match_report,
      potm_match_status: props.fixtureDetails?.potm_match_status,
      match_status: '',
    },
    enableReinitialize: true,
    onSubmit: (data, actions) => {
      setCommonScorecardLoading(true)
      data.fixtureId = props.fixtureId
      data.potm = props.selectedValue
      data.status = statusValue
      data.inning = defaultInning
      props.setLoader(true)
      ScorecardService.saveScorecard(data).then((res) => {
        if (res.status === 200) {
          setCommonScorecardLoading(false)
          props.fetchData(defaultInning)
          ToastComponent(res.message, 'success')
        }
      })
    },
  })
  useEffect(() => {
    formikRef.current = formik
  }, [formik])
  const [showResetConfirm, setShowResetConfirm] = useState(false)
  const handleResetConfirm = () => {
    resetFixtureScorecard()
    return setShowResetConfirm(false)
  }
  const handleResetCancel = () => {
    return setShowResetConfirm(false)
  }
  const clearScorecard = () => {
    setShowResetConfirm(true)
  }

  const handleResetBackConfirm = () => {
    navigate(-1)
    return setShowConfirmation(false)
  }
  const handleResetBackCancel = () => {
    formikRef.current?.handleSubmit() // This should call the onSubmit
    return setShowConfirmation(false)
  }

  const resetFixtureScorecard = () => {
    const data = {}
    data.fixtureId = props.fixtureId
    data.inning = props.defaultInning
    ScorecardService.clearFixtureScorecard(data).then((res) => {
      if (res.status === 200) {
        setCommonScorecardLoading(false)
        props.fetchData()
        ToastComponent(res.message, 'success')
      }
    })
  }

  const param = useParams()
  const [completeMarkModalData, setCompleteMarkModalData] = useState([])
  const handleMatchStatus = (e) => {
    setStatusValue(e.target.value)
    const data = {}
    data.fixtureId = param.fixtureId
    data.status = e.target.value
    data.inning = defaultInning
    if (e.target.value === '2') {
      ScorecardService.getSavedScorecardData(data).then((res) => {
        if (res.status === 200) {
          setCompleteMarkModalData(res.data)
          setCompletMarkModalVisible(true)
        }
      })
    } else {
      formikRef.current?.handleSubmit() // This should call the onSubmit
      ScorecardService.changFixtureStatus(param.fixtureId, e.target.value)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            navigate(`/scorecard/${param.fixtureId}/${param.teamId}`)
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          console.log('e', e)
          ToastComponent('Something went wrong.', 'error')
        })
    }
  }
  const changeInning = (e) => {
    setDefaultInning(e.target.value)
    props.fetchData(e.target.value)
  }

  // Detect changes in form values
  const [isFormModified, setIsFormModified] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)
  useEffect(() => {
    const handleFormChange = () => {
      const isModified = Object.keys(formik.initialValues).some(
        (key) => formik.values[key] !== formik.initialValues[key],
      )
      setIsFormModified(isModified)
    }

    // Trigger form change detection whenever formik values change
    handleFormChange()
  }, [formik]) // This will run on every form value change

  // Prevent navigation if form is modified
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isFormModified) {
        const message = 'You have unsaved changes, are you sure you want to leave?'
        e.returnValue = message // Standard for most browsers
        return message // For some browsers
      }
    }

    // Listen to the beforeunload event
    window.addEventListener('beforeunload', handleBeforeUnload)

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [isFormModified]) // Only run when form is modified

  // Handle browser back/forward navigation
  useEffect(() => {
    const handlePopState = (e) => {
      if (isFormModified) {
        // Show the confirmation dialog
        setShowConfirmation(true)

        // Prevent back navigation until the user confirms
        e.preventDefault()
      }
    }

    // Add event listener for popstate (for back/forward buttons)
    window.addEventListener('popstate', handlePopState)

    // Cleanup on unmount
    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [isFormModified]) // Only re-run when form is modified

  // ---- presentation helpers ------------------------------------------------

  const teamId = props.teamId ?? props.param?.teamId ?? param.teamId

  const enteredCount = (props.scorecardDetails || []).filter((item) =>
    hasScores(item, props.scorecardColoumns),
  ).length
  const playerCount = (props.scorecardDetails || []).length
  const enteredPercent = playerCount ? Math.round((enteredCount / playerCount) * 100) : 0

  // Both scorecard-detail fields autosave through updateCustomScorecardField on
  // change. Formik is kept in step so the Save scores payload carries what is on
  // screen - save-scorecard writes these two columns too, and would otherwise put
  // the pre-edit value back.
  const handleScorecardDetailChange = (e, type) => {
    formik.handleChange(e)
    props.handleInputChange(e, type)
  }

  // Marker on the header buttons, so a panel that already holds something reads as
  // filled without being opened.
  const scorecardDetailsSet = Boolean(
    formik.values.scorcard_link_name || formik.values.scorcard_link_url,
  )
  const bonusPointsSet =
    (props.selectedValue?.length ?? 0) > 0 ||
    ['1', '2'].includes(String(formik.values.potm_match_status ?? ''))

  const scorecardTitle = props.fixtureDetails.scorcard_link_url ? (
    <Link to={props.fixtureDetails.scorcard_link_url} target="_blank">
      Player stats
    </Link>
  ) : (
    'Player stats'
  )

  const inningsSelect = props.fixtureDetails?.match_type_name === '2-Day' && (
    <div className="d-flex align-items-center gap-2">
      <CFormLabel htmlFor="inning" className="mb-0 small fw-semibold text-medium-emphasis">
        Innings
      </CFormLabel>
      <CFormSelect
        aria-label="select inning"
        name="inning"
        onChange={changeInning}
        value={defaultInning}
        id="inning"
        style={{ width: 150 }}
      >
        <option value={1}>1st Innings</option>
        <option value={2}>2nd Innings</option>
      </CFormSelect>
    </div>
  )

  const scorecardDetailsModal = (
    <CModal
      visible={detailsModalVisible}
      onClose={() => setDetailsModalVisible(false)}
      aria-labelledby="scorecard-details-modal-title"
    >
      <CModalHeader>
        <CModalTitle id="scorecard-details-modal-title">Scorecard Details</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <InfoBox>
          Where this scorecard came from. Both fields save as you type &mdash; there is no separate
          save step here.
        </InfoBox>
        <CRow className="g-3">
          <CCol xs={12}>
            <CFormLabel htmlFor="scorcard_link_name">Scorecard Source</CFormLabel>
            <CFormInput
              type="text"
              name="scorcard_link_name"
              id="scorcard_link_name"
              placeholder="Scorecard Source"
              value={formik.values.scorcard_link_name ?? ''}
              onChange={(e) => handleScorecardDetailChange(e, 'scorcard_link_name')}
            />
            <div className="form-text">Who published it &mdash; PlayHQ, MyCricket, the club.</div>
          </CCol>
          <CCol xs={12}>
            <CFormLabel htmlFor="scorcard_link_url">Scorecard Link</CFormLabel>
            <CFormInput
              type="text"
              name="scorcard_link_url"
              id="scorcard_link_url"
              placeholder="Scorecard Link"
              value={formik.values.scorcard_link_url ?? ''}
              onChange={(e) => handleScorecardDetailChange(e, 'scorcard_link_url')}
            />
            <div className="form-text">
              Added here, the Player stats heading becomes a link to the published scorecard.
            </div>
          </CCol>
          {/* <CCol xs={12}>
            <CFormLabel htmlFor="fall_of_wickets">Fall of Wickets</CFormLabel>
            <CFormTextarea
              id="fall_of_wickets"
              aria-label="Fall of wickets"
              defaultValue={formik.values.fall_of_wickets}
              name={'fall_of_wickets'}
              onChange={(e) => props.handleInputChange(e, 'fall_of_wickets')}
            ></CFormTextarea>
          </CCol> */}
        </CRow>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={() => setDetailsModalVisible(false)}>
          Done
        </CButton>
      </CModalFooter>
    </CModal>
  )

  const bonusPointsModal = (
    <CModal
      className="sc-form-modal"
      visible={bonusModalVisible}
      onClose={() => setBonusModalVisible(false)}
      aria-labelledby="bonus-points-modal-title"
    >
      <CModalHeader>
        <CModalTitle id="bonus-points-modal-title">Bonus Points</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <InfoBox>
          Points awarded on top of the stats above. These are saved with the scores &mdash; press
          <strong> Save scores</strong> on the scorecard once you are done here.
        </InfoBox>
        <CRow className="g-3">
          <CCol xs={12}>
            <CFormLabel htmlFor="player_of_the_match">Player Of The Match</CFormLabel>
            <CMultiSelect
              id="player_of_the_match"
              options={props.playerList}
              selectionType="tags"
              name="player"
              optionsMaxHeight={220}
              onChange={props.handleChange}
              value={props.playerList.filter((obj) => props.selectedValue.includes(obj.value))}
            />
          </CCol>
          <CCol xs={12}>
            <CFormLabel htmlFor="potm_match_status">Match Result</CFormLabel>
            <CFormSelect
              id="potm_match_status"
              value={formik.values.potm_match_status}
              onChange={formik.handleChange}
            >
              <option>Select Match Result</option>
              <option value="1">Won</option>
              <option value="2">Other</option>
            </CFormSelect>
          </CCol>
        </CRow>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={() => setBonusModalVisible(false)}>
          Done
        </CButton>
      </CModalFooter>
    </CModal>
  )

  const matchStatusCard = (
    <CCard className="mt-3">
      <CCardHeader>
        <strong>Match status</strong>
        <div className="text-medium-emphasis small">
          The last step - set this once the scores above are saved. Choosing Completed opens a final
          review of the saved scorecard.
        </div>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md={6}>
            <div className="d-flex align-items-center gap-2">
              <CFormSelect
                aria-label="Select Structure"
                name="match_status"
                value={props.statusValue}
                id="match_status"
                onChange={(e) => {
                  formik.handleChange(e)
                  handleMatchStatus(e)
                }}
              >
                <option value={0}>Select Match Status </option>
                <option value={1}>In-Progress</option>
                <option value={2}>Completed</option>
              </CFormSelect>
              <CTooltip content="What the match statuses mean">
                <CButton
                  color="secondary"
                  variant="ghost"
                  onClick={() => props.setVisible(!props.visible)}
                  aria-label="Match status help"
                >
                  <CIcon icon={cilInfo} />
                </CButton>
              </CTooltip>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  )

  return commonScorecardLoading ? (
    <Loader />
  ) : (
    <>
      <CForm onSubmit={formik.handleSubmit}>
        <div className="ge-page-header">
          <button type="button" className="ge-back-link" onClick={() => navigate(-1)}>
            <CIcon icon={cilArrowLeft} />
            Manage Scores
          </button>
          <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
            <div>
              <h1 className="ge-page-title">Scorecard &mdash; {props.fixtureDetails.team_name}</h1>
              <p className="ge-page-subtitle">
                Enter each player&rsquo;s stats for this innings. Fantasy points are recalculated
                when you save.
              </p>
            </div>
            <div className="d-flex flex-wrap gap-2">
              <CButton
                color="secondary"
                variant="outline"
                href={`/manage-scores/team-players/${props.fixtureId}/${teamId}`}
              >
                <CIcon icon={cilList} className="me-1" />
                Squad
              </CButton>
              <CButton color="secondary" variant="outline" onClick={props.handleInfoClick}>
                <CIcon icon={cilInfo} className="me-1" />
                Column legend
              </CButton>
            </div>
          </div>
        </div>

        <div className="ge-meta-strip">
          <div className="ge-meta-item">
            <span className="ge-meta-label">Round</span>
            <span className="ge-meta-value">{props.fixtureDetails.round}</span>
          </div>
          <div className="ge-meta-item">
            <span className="ge-meta-label">Team</span>
            <span className="ge-meta-value">{props.fixtureDetails.team_name}</span>
          </div>
          <div className="ge-meta-item">
            <span className="ge-meta-label">Starts</span>
            <span className="ge-meta-value">
              {moment(props.fixtureDetails.start_date).format('D MMM YYYY')}
              {', '}
              {moment(props.fixtureDetails.start_time, ['HH:mm']).format('h:mma')}
            </span>
          </div>
          <div className="ge-meta-item">
            <span className="ge-meta-label">Ends</span>
            <span className="ge-meta-value">
              {moment(props.fixtureDetails.end_date).format('D MMM YYYY')}
              {', '}
              {moment(props.fixtureDetails.end_time, ['HH:mm']).format('h:mma')}
            </span>
          </div>
        </div>

        <div className="sc-toolbar">
          <div className="d-flex flex-wrap align-items-center gap-3">{inningsSelect}</div>
          <div className="d-flex align-items-center gap-2">
            <span className="small fw-medium text-medium-emphasis">
              {enteredCount} of {playerCount} players have scores saved
            </span>
            <div className="sc-progress-track">
              <div className="sc-progress-fill" style={{ width: `${enteredPercent}%` }} />
            </div>
          </div>
        </div>

        <CCard className="mb-4">
          <CCardHeader className="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <strong>{scorecardTitle}</strong>
            <div className="sc-header-actions">
              <CTooltip content="Scorecard Details">
                <CButton
                  color="secondary"
                  variant="ghost"
                  className="sc-icon-btn"
                  onClick={() => setDetailsModalVisible(true)}
                  aria-label="Scorecard Details"
                >
                  <CIcon icon={cilLink} size="lg" />
                  {scorecardDetailsSet && <span className="sc-icon-btn-dot" aria-hidden="true" />}
                </CButton>
              </CTooltip>
              <CTooltip content="Bonus Points">
                <CButton
                  color="secondary"
                  variant="ghost"
                  className="sc-icon-btn"
                  onClick={() => setBonusModalVisible(true)}
                  aria-label="Bonus Points"
                >
                  <CIcon icon={cilStar} size="lg" />
                  {bonusPointsSet && <span className="sc-icon-btn-dot" aria-hidden="true" />}
                </CButton>
              </CTooltip>
            </div>
          </CCardHeader>
          <CCardBody>
            {props.loader ? (
              <Loader />
            ) : (
              <ScorecardGrid
                columns={props.scorecardColoumns}
                rows={props.scorecardDetails}
                isMobile={props.isMobile}
                onChange={formik.handleChange}
                formatFantasyPoints={props.formatFantasyPoints}
              />
            )}
          </CCardBody>
        </CCard>

        <div className="sc-savebar sc-savebar--pinned">
          <span className="small text-medium-emphasis">
            {enteredCount} of {playerCount} players have scores saved. Saving recalculates fantasy
            points for this innings.
          </span>
          <div className="d-flex flex-wrap align-items-center gap-2">
            {props.isMobile && (
              <CButton color="danger" variant="outline" onClick={clearScorecard}>
                <CIcon icon={cilReload} className="me-1" />
                Reset
              </CButton>
            )}
            <CLoadingButton type="submit" color="primary" loading={props.loader}>
              Save scores
            </CLoadingButton>
          </div>
        </div>

        {matchStatusCard}
      </CForm>

      {scorecardDetailsModal}
      {bonusPointsModal}

      <Bootbox
        show={showResetConfirm}
        type={'confirm'}
        message={'Are you sure you want to reset this?'}
        onSuccess={handleResetConfirm}
        onCancel={handleResetCancel}
        onClose={handleResetCancel}
      />
      <CompleteMarkModal visible={visible} setVisible={setVisible} />
      <MarkAsCompleteModal
        completMarkModalVisible={completMarkModalVisible}
        setCompletMarkModalVisible={setCompletMarkModalVisible}
        data={completeMarkModalData}
        fixtureId={param.fixtureId}
        finalScorecardModalVisible={finalScorecardModalVisible}
        setFinalScorecardModalVisible={setFinalScorecardModalVisible}
      />
      <Bootbox
        show={showConfirmation}
        type={'confirm'}
        message={
          'You are exiting without saving unsaved data. Are you sure you want to discard the changes?'
        }
        onSuccess={handleResetBackConfirm}
        onCancel={handleResetBackCancel}
        onClose={handleResetBackCancel}
        buttons={{
          confirm: {
            label: 'Save & Exit', // Customize the button label here
            className: 'btn-primary', // Optionally, change the button class for styling
          },
          cancel: {
            label: 'Discard & Exit', // Customizing 'Cancel' button
            className: 'btn-danger', // Optional: Add custom class for styling
          },
        }}
      />
    </>
  )
}

export default CommonScorecard
